export function MacroDashLogo({ size = 16 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="5 8 22 16"
      width={size}
      height={size * (16 / 22)}
      className="shrink-0 self-center translate-y-px"
    >
      {/* > chevron */}
      <path
        d="M7 10 L14 16 L7 22"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* _ underscore */}
      <line
        x1="16" y1="22" x2="25" y2="22"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
